<template>
    <div>
        <ul class="conditions-list">
            <li class="condition" v-if="questionK > 0 && edit && conditions.length > 1">
                <div class="mb">
                    <span>Règles des conditions : <i>condition_1 ET condition_2 OU condition_3 OU condition_4 ET condition_5...</i></span>
                    <textarea type="text" :value="question.pattern" @change="changePattern($event)" :class="'c_'+refresh"></textarea>
                </div>
            </li>
            <condition v-for="(condition,key) in conditions" :condition="condition" :key="key" :k="key" @remove="remove" :questionId="question.id"></condition>
        </ul>
        <div class="line option" v-if="questionK > 0 && edit">
            <btn text="Ajouter une condition" ico="add" @click="add"></btn>
        </div>
        <div v-else-if="edit" class="line">
            <p class="badge-small"><i>Condition non disponible pour la première question</i></p>
        </div>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    import Condition from "@/components/questionnaire/Condition";
    import tools from '../../config.ts';

    export default {
        name: "Conditions",
        components: {Condition, Btn},
        props: {
            conditions: {},
            question: {},
            questionK:0,
            edit:false,
        },
        data() {
            return {
                defaultCondition: {
                    question: 0,
                    responses: {
                        equal: "equal",
                        value: "",
                    },
                },
                refresh:0
            }
        },
        methods: {
            add() {
                this.conditions.push(JSON.parse(JSON.stringify(this.defaultCondition)))
                
                this.rebuildPattern(false)
                // console.log(this.question.pattern)
                tools.$emit("updateQuestions")
                // console.log(this.question.pattern)
            },
            remove(key) {
                this.conditions.splice(key, 1);

                if(this.conditions.length === 1){
                    this.pattern = " condition_1 ";
                }else{
                    this.rebuildPattern(true)
                }
                
                tools.$emit("updateQuestions")
            },
            changePattern($event){
                this.question.pattern = $event.target.value
                tools.$emit("updateQuestions")
            },
            rebuildPattern(del){
                // on recrée le pattern
                let news = false;
                let pattern = "";
                let currentPattern = this.question.pattern;
                if(!currentPattern) currentPattern = "";
                
                this.conditions.forEach((condition,key) => {
                    let regex = new RegExp("condition_"+(key+1)+" ?([ETOU]+)?");
                    let res = currentPattern.match(regex);
        
                    if(res){
                        if(!res[1]){
                            res[1] = key === this.conditions.length - 1 ? "" : "ET";
                        }
                        pattern += "condition_"+(key+1)+" "+res[1]+" "
                    }else{
                        pattern += "condition_"+(key+1)+" ET ";
                        news = true
                    }
                });
    
                if(news || del){
                    pattern = pattern.substr(0,pattern.length - 4);
                }
                // console.log(pattern)
                this.question.pattern = pattern
                this.refresh++;
            }
        },
        computed:{
            pattern:{
                set(value){
                    this.question.pattern = value;
                    // console.log(this.question.pattern)
                    tools.$emit("updateQuestions")
                },
                get(){
                    
                    return this.question.pattern;
                    // let currentPattern = this.$store.getters.getCurrentQuestions[this.questionK].pattern;
                    // let pattern = "";
                    //
                    // if(!currentPattern || currentPattern === ""){
                    //
                    //     this.conditions.forEach((condition,key) => {
                    //         pattern += "condition_"+(key+1)+" ET "
                    //     });
                    //
                    //     pattern = pattern.substr(0,pattern.length - 4);
                    //
                    //     return pattern;
                    // }
                    //
                    // let news = false;
                    // this.conditions.forEach((condition,key) => {
                    //     let regex = new RegExp("condition_"+(key+1)+" ?([ETOU]+)?");
                    //     let res = currentPattern.match(regex);
                    //
                    //     if(res){
                    //         if(!res[1]){
                    //             res[1] = key === this.conditions.length - 1 ? "" : "ET";
                    //         }
                    //         pattern += "condition_"+(key+1)+" "+res[1]+" "
                    //     }else{
                    //         pattern += "condition_"+(key+1)+" ET ";
                    //         news = true
                    //     }
                    // });
                    //
                    // if(news){
                    //     pattern = pattern.substr(0,pattern.length - 4);
                    // }
                    //
                    // return pattern;
                }
            }
        },
        mounted(){

        }
    }
</script>
